import { FilterWrapper } from "./types/classes/FilterWrapper";

// Filter Interfaces
export interface IFilter {
    id: number | null;
    name: string;
    scope: string;
    teamId?: number | null;
    createdById?: number | null;
    sectorFilter: string | null;
    ownershipFilter: string | null;
    isOwnFilter?: boolean;
    isDraft: boolean;
    tempId?: string;
}

export interface IFilterForm {
    id: number | null;
    name: string;
    scope: string;
    isOwnFilter: boolean;
    isDraft: boolean;
    tempId?: string;
    // sectorFilter: string | null; 
    // ownershipFilter: string | null; 
    filters: FilterWrapper
}

// This is to fill and choose msi ownerships list from other slice 
export interface IOwnershipForm {
    companyName: string;
}

// Enums
export enum ScopeOptions {
    Personal = 'Personal',
    Team = 'Team'
}


export const FILTER = 'filter';

export const actionTypes = {
    ADD_FILTER_REQUEST_ACTION: `${FILTER}/addFilterRequest`,
    UPDATE_FILTER_REQUEST_ACTION: `${FILTER}/updateFilterRequest`,
    DELETE_FILTER_REQUEST_ACTION: `${FILTER}/deleteFilterRequest`,
    GET_FILTERS_REQUEST_ACTION: `${FILTER}/getFiltersRequest`,
    GET_FILTER_REQUEST_ACTION: `${FILTER}/getFilterRequest`,    
    DISPLAY_OUTPUT_BY_FILTER_ID_REQUEST_ACTION: `${FILTER}/displayOutputByFilterIdRequest`,
    DELETE_DRAFT_FILTER_REQUEST_ACTION: `${FILTER}/deleteDraftFilterRequest`,
}